// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimsList-cls1_Yin","cls2":"ClaimsList-cls2__1K ClaimsList-cls1_Yin"};